const bitrates = [
  { value: 128, display: "low" },
  { value: 256, display: "medium" },
  { value: 512, display: "high" },
  { value: 1024, display: "veryHigh" },
  { value: 0, display: "unlimited" }
];

export default bitrates;
